import {
    StepVariables,
    ToolContext
} from "@omni/types/components/tracking/tracking-info/tools/toolStep.trackingInfo";
import { PageTemplate } from "@omni/types/enums/pageTemplate.enum";
import { hasWindow } from "@omni/utils/dom.utils";

import { isPageTemplate } from "@/utils/pageTemplate.utils";

type StepTypes = "start" | "submit";

const isCheckoutPage = () =>
    hasWindow() && isPageTemplate(PageTemplate.Checkout);

const placement = isCheckoutPage() ? "bestellen:login" : "klantgegevens:login";

const TOOL_LOGIN_STEPS: Record<StepTypes, StepVariables> = {
    start: {
        stepName: "Bestaande klanten",
        stepNumber: 1,
        placement: placement,
        result: {},
        option: ""
    },
    submit: {
        stepName: "succesvol ingelogd",
        stepNumber: 2,
        placement: placement,
        result: {},
        option: ""
    }
};

const TOOL_LOGIN_CONTEXT: Readonly<ToolContext> = {
    name: "login",
    type: "form"
};

export { TOOL_LOGIN_CONTEXT, TOOL_LOGIN_STEPS };
